module.exports = __webpack_public_path__ + "static/img/icon-configDefult.3b6d20fa.png";